import { signal, computed } from '@preact/signals';

export interface User {
  id: number;
  email: string;
  name: string;
  is_admin: boolean;
}

export const user = signal<User | null>(null);
export const token = signal<string | null>(localStorage.getItem('token'));
export const isAuthenticated = computed(() => !!token.value && !!user.value);

export function setAuth(newToken: string, newUser: User) {
  token.value = newToken;
  user.value = newUser;
  localStorage.setItem('token', newToken);
}

export function clearAuth() {
  token.value = null;
  user.value = null;
  localStorage.removeItem('token');
}
